<template>
  <div>
    <PlanUpgradeTooltip
      v-if="isShowTooltip"
      :popup="popup"
      :planForFeature="planForFeature"
      :left="left"
      @clickOutsideUpgrade="clickOutsideUpgrade"
      @openPlanUpgradeModal="openPlanUpgradeModal"
    >
      <template #tooptip v-if="$slots.tooltipcontent">
        <slot name="tooltipcontent" />
      </template>
    </PlanUpgradeTooltip>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PlanUpgradeTooltip from '@/components-v2/presentation-editor/editor-header/PlanUpgradeTooltip.vue'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  name: 'EditorPlan',
  components: {
    PlanUpgradeTooltip,
  },
  props: {
    isShowTooltip: {
      type: Boolean,
      default: false,
    },
    planForFeature: {
      type: String,
      default: 'Pro',
    },
    nameFeature: {
      type: String,
      default: '',
    },
    textTooltip: {
      type: String,
      default: 'Upgrade to Pro to use this feature',
    },
    popup: {
      type: String,
      default: '',
    },
    left: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
    }),
  },
  methods: {
    openPlanUpgradeModal() {
      Util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Feature upgrade',
        this.nameFeature,
      )
      return this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
    clickOutsideUpgrade() {
      this.$emit('outsideEvent')
    },

  },
}
</script>

<style lang="scss" scoped>

</style>
